import React from "react";
import { ANIMATED_FLAG_CODES, NOVELTY_FLAG_CODES, flagName, flagUrl, flagUrlSquare } from "../../shared/flags";

// Dev gallery for the purchasable novelty (shop) flags: each shown as the round icon
// (player bars / scoreboards) and the square card (pickers / shop). Route: /flagshop
const LINE = "rgba(255,255,255,0.10)";

export default function NoveltyFlagsDemo() {
  return (
    <div style={{ minHeight: "100vh", background: "#0b1020", padding: 32, fontFamily: "'Rajdhani',sans-serif", color: "#eaf0ff" }}>
      <h1 style={{ fontSize: 22, fontWeight: 900, letterSpacing: 1, marginBottom: 4 }}>NOVELTY FLAGS (SHOP)</h1>
      <div style={{ color: "#8b93a7", fontSize: 14, marginBottom: 24 }}>
        The purchasable set from NOVELTY_FLAG_CODES. Country flags stay free; the shop sells these.
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 14, maxWidth: 1100 }}>
        {NOVELTY_FLAG_CODES.map((code) => (
          <div key={code} style={{ background: "#141b2b", border: `1px solid ${LINE}`, borderRadius: 10, padding: 14, display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
            {/* Square card first: it's the shop's default flag view; round is secondary. */}
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <img src={flagUrlSquare(code)} alt="" style={{ width: 72, height: 72, display: "block", borderRadius: 8 }} />
              <img src={flagUrl(code)} alt="" style={{ width: 44, height: 44, display: "block" }} />
            </div>
            <div style={{ fontWeight: 800, fontSize: 15 }}>{flagName(code)}</div>
            <div style={{ color: "#8b93a7", fontSize: 11 }}>{code}</div>
            {ANIMATED_FLAG_CODES.includes(code) && (
              <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: "#ffd21f", border: "1px solid rgba(255,210,31,0.4)", borderRadius: 5, padding: "1px 7px" }}>ANIMATED</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
